import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.scss';
import { RepInfoBox } from '../RepInfoBox';
import { capitalizeString, formatPhoneNumber } from '../../../utils';
import { SearchedUser, UserStatus } from '../../../services/usersService/usersServiceQuery';
import { isRepAdminSelector, isShipperAdminEnabledSelector } from '../../../store/manageUsers/selectors';
import { useAppSelector } from '../../../store';
import { IconButton, KeyboardArrowDown } from 'drift-ui';
import { useUserLanguages } from '@Common/userLanguage';

type Props = {
  user: SearchedUser;
  defaultOpen: boolean;
};
const CarrierDirectoryItem = ({ user, defaultOpen }: Props) => {
  const { t, i18n } = useTranslation();
  const [openDirectoryRep, setOpenDirectoryRep] = useState(defaultOpen);
  const isShipperAdmin = useAppSelector(isShipperAdminEnabledSelector);
  const isRepAdmin = useAppSelector(isRepAdminSelector);
  const isExclusivelyShipperAdmin = isShipperAdmin && !isRepAdmin;
  const userLanguages = useUserLanguages(user.language, user.device_info?.devices_by_language);

  const statusLabel = useMemo(() => {
    switch (user.status) {
      case UserStatus.Active:
        return t('active');
      case UserStatus.Inactive:
        return t('inactive');
      // TODO: Add translations for remaining statuses
      default:
        return user.status;
    }
  }, [i18n.language, user.status]);

  return (
    <div className={styles['container-item']}>
      <div className={styles['table-row']}>
        <div className={`${styles['table-cell']} ${user.name ? styles['name'] : styles['trialName']}`}>
          <p className={styles['cell-text']}>{user.name ?? 'Trial User'}</p>
        </div>
        <div className={styles['table-cell']}>
          <p className={styles['cell-text']}>{user.company?.toLocaleUpperCase()}</p>
        </div>
        <div className={styles['table-cell']}>{user.company_id}</div>
        <div className={styles['table-cell']}>
          <p className={styles['cell-text']}>{user.email}</p>
        </div>
        <div className={styles['table-cell']}>{formatPhoneNumber(user.phone)}</div>
        <div className={styles['table-cell']}>{capitalizeString(statusLabel)}</div>
      </div>
      {!isExclusivelyShipperAdmin && (
        <div className={styles['rep-button']} onClick={() => setOpenDirectoryRep(!openDirectoryRep)}>
          <div className={styles.dropdownContainer}>
            <span style={{ marginRight: '5px' }}>View Rep Directory</span>
            <IconButton>
              <KeyboardArrowDown className={openDirectoryRep ? styles['rotated'] : ''} />
            </IconButton>
          </div>

          <div className={styles.languageContainer}>
            <p className={styles.boldText}>Language Preference:</p>
            <p className={styles.regularText}>{userLanguages}</p>
          </div>
        </div>
      )}
      {openDirectoryRep && <RepInfoBox email={user.email} />}
    </div>
  );
};

export default CarrierDirectoryItem;
